module.exports = __webpack_public_path__ + "img/spint-gold.e258c30d.png";